import React, { useState } from "react";
import "fontsource-roboto";
import AppBar from "./AppBar";
import ThemeProvider from "../../config/ThemeProvider";
import Body from "./Body";
import NavigationDrawer from "./NavigationDrawer";

const App = () => {
  const [open, setOpen] = useState(false);

  return (
    <ThemeProvider>
      <AppBar openDrawer={() => setOpen(true)} />
      <NavigationDrawer
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
      />
      <Body />
    </ThemeProvider>
  );
};

export default App;
